import { PermissionsEnum } from '@/auth/interfaces';
import { SaveMotivoPage } from '../../shared/saveMotivo';
import { useCheckPermissions } from '@/shared';

export interface CreateMotivoPageInterface {}

const CreateMotivoPage: React.FC<CreateMotivoPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_motivo)
  return <SaveMotivoPage titlePage="Crear Motivo" />;
};

export default CreateMotivoPage;
